import { render } from "./EarLobeRepairContentEn.vue?vue&type=template&id=17d07ff2"
import script from "./EarLobeRepairContentEn.vue?vue&type=script&lang=js"
export * from "./EarLobeRepairContentEn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__